import { render, staticRenderFns } from "./regisInfo.vue?vue&type=template&id=de1982c4&scoped=true"
import script from "./regisInfo.vue?vue&type=script&lang=js"
export * from "./regisInfo.vue?vue&type=script&lang=js"
import style0 from "./regisInfo.vue?vue&type=style&index=0&id=de1982c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1982c4",
  null
  
)

export default component.exports